module.exports = __webpack_public_path__ + "static/img/2022620422433363721.736328b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/UploadFile/1/Img/2022620422433363721.jpg
// module id = zLYr
// module chunks = 1